<template>
    <form method="POST" action="/admin/statistics/bonuses/excel">
        <input type="hidden" name="_token" value="" id="orders_form_token">
        <div class="row">
            <div class="col-md-9">
                <date-range-picker></date-range-picker>
                <div class="form-group clearfix"><div class="col-md-12"><strong>или</strong></div></div>
                <orders-checker></orders-checker>
                <div class="form-group">
                    <div>
                        <input
                                v-for="column in columns"
                                type="hidden"
                                :name="'columns[' + column.code + ']'"
                                :value="column.title"
                        >
                    </div>
                </div>
            </div>
            <div class="col-md-3" style="margin-top: 24px">
                <div class="form-group">
                    <div class="btn btn-primary form-control" @click="load">
                        <i v-show="is_loading" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                        <span v-show="!is_loading">
                            <i class="fa fa-file-excel-o"></i>
                            Выгрузить данные
                        </span>
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-success form-control">
                        <i class="fa fa-file-excel-o"></i>
                        Сохранить в Excel
                    </button>
                </div>
            </div>
        </div>
        <br><br>
        <statistics-counting
                :data="bonuses"
                :data_for_counting="data_for_counting"
        ></statistics-counting>
        <div class="row" v-show="bonuses.length">
            <div class="col-md-12">
                <h3>Всего бонусов: {{ bonuses.length }}</h3>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>№</th>
                            <th v-for="column in columns">{{ column.title }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(bonus, key) in bonuses">
                            <td><b>{{ key + 1 }}.</b></td>
                            <td v-for="column in columns">{{ bonus[column.code] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    mounted: function() {
        this.setTokens();
    },
    data: function () {
        let columns = [
            { code: 'domain_title', title: 'Домен' },
            { code: 'bonus_title', title: 'Название' },
            { code: 'sent_bonuses_count', title: 'Количество отправленных бонусов' },
            { code: 'bonuses_count_in_compilation', title: 'Количество бонусов в заказах в сборке' },
            { code: 'purchase_price', title: 'Цена закупки 1 сувенира' },
            { code: 'purchase_sum', title: 'Сумма закупки' },
        ];

        /**
         * types: total or average
         */
        let data_for_counting = [
            {
                type: 'total',
                name: 'Общая сумма закупки',
                append_to_result: 'евро',
                column_code: 'purchase_sum',
            },
        ];

        return {
            bonuses: [],
            date_start: '',
            date_finish: '',
            order_params: '',
            columns: columns,
            is_loading: false,
            data_for_counting: data_for_counting,
        };
    },
    methods: {
        setTokens: function () {
            let token = document.querySelector('#token').getAttribute('content');
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
            document.querySelector('#orders_form_token').value = document.querySelector('#token').getAttribute('content');
        },
        load: function () {
            if (!this.checkEnteredData()) {
                alert('Заполните обязательные поля!');
                return;
            }

            let self = this;
            this.is_loading = true;

            let data = {
                columns: this.getNormalizedArr(this.columns, 'code', 'title')
            };

            if(!!(this.date_start && this.date_finish)) {
                data.date_start = this.date_start;
                data.date_finish = this.date_finish;
            }

            if(this.order_params.length) {
                data.order_params = this.order_params;
            }

            this.$http.post(
                '/statistics/bonuses/get', data
            ).then(function (response) {
                self.is_loading = false;
                self.bonuses = response.data;
            }, function (response) {
                this.show_loader = false;

                let errors = '';
                for (let field in response.data.errors) {
                    errors += response.data.errors[field] + '\r\n';
                }

                alert(errors);
            });
        },
        getNormalizedArr: function (arr, key, value) {
            let columns = {};
            arr.forEach(function (item) {
                columns[item[key]] = item[value];
            });

            return columns;
        },
        checkEnteredData: function () {
            return (this.date_start && this.date_finish || this.order_params.length);
        },
    },
    created: function () {
        this.$root.$on('update:date_range', (val) => { this.date_start = val.date_start; this.date_finish = val.date_finish; });
        this.$root.$on('update:order_params', (val) => { this.order_params = val; });
    }
};
</script>
